<div class="row">
  <div class="col-md-12 m-b-md">
    <p>
      Licensing partners own the rights to the IPSAT with their region and can
      sell their own licenses.
    </p>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">Name</label>
    <input
      type="text"
      placeholder="Nexleader, LLC."
      class="form-control"
      [(ngModel)]="model.name"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">Region</label>
    <input
      type="text"
      placeholder="North America"
      class="form-control"
      [(ngModel)]="model.region"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">ISO 4217 Currency Code for Presentment</label>
    <input
      type="text"
      placeholder="North America"
      class="form-control"
      [(ngModel)]="model.currencyCode"
    />
  </div>
</div>
<div class="row">
  <div class="form-group col-md-6">
    <label class="control-label"
      >Organizational Faith-based IPSAT Price<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.ipsatLicense.organizationalFaithBased"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Organizational Values-based IPSAT Price<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.ipsatLicense.organizationalValuesBased"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Independent Contractor Faith-based IPSAT Price<span
        *ngIf="model.currencyCode"
      >
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.ipsatLicense.independentContractorFaithBased"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Independent Contractor Values-based IPSAT Price<span
        *ngIf="model.currencyCode"
      >
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.ipsatLicense.independentContractorValuesBased"
    />
  </div>
</div>
<div class="row">
  <div class="form-group col-md-6">
    <label class="control-label"
      >Faith-based Team Report Price Per User<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.teamReport.faithBased.perUser"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Faith-based Team Report Price Minimum<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.teamReport.faithBased.min"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Faith-based Team Report Price Maximum<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.teamReport.faithBased.max"
    />
  </div>
</div>
<div class="row">
  <div class="form-group col-md-6">
    <label class="control-label"
      >Values-based Team Report Price Per User<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.teamReport.valuesBased.perUser"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Values-based Team Report Price Minimum<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.teamReport.valuesBased.min"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Values-based Team Report Price Maximum<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.teamReport.valuesBased.max"
    />
  </div>
</div>
<div>
  <div class="row">
    <div class="form-group col-md-6">
      <label class="control-label"
        >Faith-based Direct Purchase IPSAT with Coaching Session Price Per
        User<span *ngIf="model.currencyCode">
          in ({{ model.currencyCode }})</span
        ></label
      >
      <input
        type="number"
        placeholder="30"
        class="form-control"
        [(ngModel)]="
          model.pricing.ipsatDirectPurchase.faithBasedPlusCoachingSession
        "
      />
    </div>
    <div class="form-group col-md-6">
      <label class="control-label"
        >Values-based Direct Purchase IPSAT with Coaching Session Price Per
        User<span *ngIf="model.currencyCode">
          in ({{ model.currencyCode }})</span
        ></label
      >
      <input
        type="number"
        placeholder="20"
        class="form-control"
        [(ngModel)]="
          model.pricing.ipsatDirectPurchase.valuesBasedPlusCoachingSession
        "
      />
    </div>
    <div class="form-group col-md-6">
      <label class="control-label"
        >Clifton Strengths Assessment Price Per User<span
          *ngIf="model.currencyCode"
        >
          in ({{ model.currencyCode }})</span
        ></label
      >
      <input
        type="number"
        placeholder="20"
        class="form-control"
        [(ngModel)]="
          model.pricing.ipsatDirectPurchase.cliftonStrengthsAssessment
        "
      />
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label class="control-label"
        >IPSAT Ecourse Bundle<span *ngIf="model.currencyCode">
          in ({{ model.currencyCode }})</span
        ></label
      >
      <input
        type="number"
        placeholder="30"
        class="form-control"
        [(ngModel)]="model.pricing.ipsatEcourseDirectPurchase.valuesBasedBundle"
      />
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label class="control-label">Clifton Strengths Assessment Code</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="model.cliftonStrengthsCode"
      />
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label class="control-label"
        >ECourse Content Upgrade for Non-Ecourse User<span
          *ngIf="model.currencyCode"
        >
          in ({{ model.currencyCode }})</span
        ></label
      >
      <input
        type="number"
        placeholder="279"
        class="form-control"
        [(ngModel)]="model.pricing.ecourseContentUpgrade"
      />
    </div>
  </div>
</div>

<!-- IPSAT 2.0 Archetype Report Pricing -->
<div class="row m-t-lg">
  <div class="col-md-12 m-b-md">
    <h4 class="text-primary-2">IPSAT 2.0 Archetype Report Pricing</h4>
    <p>
      Set the price for IPSAT 2.0 Archetype Reports. Users can purchase these
      reports to unlock deeper insights about their archetype profile.
    </p>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Faith-based Archetype Report Price<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="99"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReport.faithBased"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Values-based Archetype Report Price<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="99"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReport.valuesBased"
    />
  </div>
  <div class="col-md-12 m-t-sm m-b-sm">
    <p class="text-muted">
      Optional upgrade pricing for existing IPSAT 1.0 users purchasing the 2.0
      report. Leave blank to charge them the standard price above.
    </p>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Faith-based 1.0&nbsp;&rarr;&nbsp;2.0 Upgrade Price<span
        *ngIf="model.currencyCode"
      >
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="15"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReport.faithBasedUpgrade"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Values-based 1.0&nbsp;&rarr;&nbsp;2.0 Upgrade Price<span
        *ngIf="model.currencyCode"
      >
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="15"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReport.valuesBasedUpgrade"
    />
  </div>
  <div class="col-md-12 m-t-sm m-b-sm">
    <p class="text-muted">
      Price to refresh (regenerate) an existing 2.0 report after a user updates
      their self-authored statements &mdash; e.g. following a coaching session.
      Defaults to 5.
    </p>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Faith-based Report Refresh Price<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="5"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReport.faithBasedRefresh"
    />
  </div>
  <div class="form-group col-md-6">
    <label class="control-label"
      >Values-based Report Refresh Price<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="5"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReport.valuesBasedRefresh"
    />
  </div>
</div>

<!--
  IPSAT 2.0 Direct Purchase Pricing (Steve 2026-09-08).

  These three prices drive the public 2.0 direct-purchase checkout and had no
  fields here at all, so they could only ever take their built-in defaults
  (149 / 299 / 20). That is why the Clifton add-on read $20 at checkout while
  the backend showed $25 — the $25 was entered against the 1.0 field below,
  which the 2.0 checkout does not consult.
-->
<div class="row m-t-lg">
  <div class="col-md-12 m-b-md">
    <h4 class="text-primary-2">IPSAT 2.0 Direct Purchase Pricing</h4>
    <p>
      What someone pays when they buy the IPSAT 2.0 Report directly from the
      public site. These are separate from the 1.0 direct purchase prices lower
      down the page &mdash; editing those has no effect on a 2.0 checkout.
    </p>
  </div>
  <div class="form-group col-md-4">
    <label class="control-label"
      >Report Only<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="149"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReportDirectPurchase.reportOnly"
    />
  </div>
  <div class="form-group col-md-4">
    <label class="control-label"
      >Report + Coaching Session<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="499"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReportDirectPurchase.coachingWithReport"
    />
    <span class="help-block small">
      The report is included in this price, not added to it.
    </span>
  </div>
  <div class="form-group col-md-4">
    <label class="control-label"
      >Clifton Strengths Add-on<span *ngIf="model.currencyCode">
        in ({{ model.currencyCode }})</span
      ></label
    >
    <input
      type="number"
      placeholder="25"
      class="form-control"
      [(ngModel)]="model.pricing.archetypeReportDirectPurchase.cliftonStrengthsAssessment"
    />
    <span class="help-block small">
      Applies to 2.0 checkouts only.
    </span>
  </div>
</div>
